import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../../report/reportActions';

import { Button } from '../../components/buttons';
import { DataTable, Page, PageContent, PageHeader, Table } from '../../components/common';
import Utils, { SecurityRoles, BouncedEmailStatus } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	bouncedEmails: BouncedEmail[];
}
interface State {
	currentIdLoading: string;
}
class BouncedEmailsListPage extends React.Component<Props, State> {
	state = {
		currentIdLoading: ''
	};

	componentDidMount() {
		this.props.actions.fetchBouncedEmails();
	}

	download = () => {
		const formattedEmails = this.formatData(this.props.bouncedEmails);
		Utils.downloadCsv(formattedEmails, 'BouncedEmails.csv');
	}
	formatData = (bouncedEmails: BouncedEmail[]) => {
		const formattedEmails = bouncedEmails.map(e => {
			return {
				Date: Utils.formatUnixDate(e.timestamp, 'lll'),
				Email: e.email,
				Reason: e.reason,
				Status: e.statusId === BouncedEmailStatus.Unresolved ? 'Unresolved' : 'Resolved'
			};
		});

		return formattedEmails;
	}

	markResolved = (id: string) => {
		this.setState({ currentIdLoading: id });
		this.props.actions.resolveBouncedEmail(id).then(() => this.setState({ currentIdLoading: '' }));
	}

	render() {
		const { ...props } = this.props;
		return (
			<Page title="Bounced emails">
				<PageContent>
					<PageHeader title="Bounced emails in the past 30 days" />
					<div className="content-set">
						{props.bouncedEmails.length > 0 &&
							<div className="table-options">
								<div className="btn-group table-filters">
									<div className="table-filter">
										<Button
											className="btn-outline-primary"
											onClick={this.download}
										>
											<span className="align-middle mx-2">Download</span>
										</Button>
									</div>
								</div>
							</div>
						}
						<DataTable
							TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
							columns={[
								{
									Header: 'Date',
									accessor: 'timestamp',
									Cell: (row: any) => Utils.formatUnixDate(row.value, 'lll')
								},
								{
									Header: 'Email',
									accessor: 'email'
								},
								{
									Header: 'Reason',
									accessor: 'reason'
								},
								{
									Header: 'Status',
									className: 'p-0 td-actions',
									accessor: 'statusId',
									Cell: (row: any) => {
										if (row.value === BouncedEmailStatus.Unresolved) {
											return (
												<Button
													className="btn-primary btn-td"
													type="button"
													onClick={() => this.markResolved(row.original.id)}
													disabled={this.state.currentIdLoading === row.original.id}
												>
													Mark as resolved
												</Button>
											);
										} else {
											return (
												<Button className="btn-secondary btn-td" type="button" disabled={true}>
													Resolved
												</Button>
											);
										}
									}
								}
							]}
							getTrProps={(state: any, rowInfo: any, column: any) => {
								return {
									className: 'tr'
								};
							}}
							data={props.bouncedEmails}
							noDataText="No bounced emails"
							resizable={true}
						/>
					</div>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		bouncedEmails: state.report.bouncedEmails
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(BouncedEmailsListPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/BouncedEmailsListPage.tsx